import { useLocation } from "react-router-dom";

import { T } from "@repo/transifex";
import { ScannerListener, scanToastError } from "~/components/scanner-listener";
import { useIdentifyUser } from "~/hooks/use-identify-user";
import { useFindProductKiosk } from "~/routes/__app.kiosk/use-find-product-kiosk";
import {
  useKioskDiningOption,
  useKioskSession
} from "~/stores/kiosk-session/hooks/use-kiosk-session";
import { ModalLoadingGeneric } from "~/components/kiosk/ui/modals/loading/modal-loading-generic";
import { kioskActions } from "~/stores/kiosk-session/actions";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { ModalErrorQr } from "~/components/kiosk/ui/modals/error/modal-error-qr";
import { ModalErrorBarcode } from "~/components/kiosk/ui/modals/error/modal-error-barcode";

function canScan(pathname: string) {
  return (
    !pathname.includes("/kiosk/basket/payment") &&
    !pathname.includes("/kiosk/order-confirmation") &&
    !/^\/kiosk\/products\/[A-Za-z0-9]+$/.test(pathname)
  );
}

export const KioskScannerListener = () => {
  const { pathname } = useLocation();
  const { locale } = useCurrentTillLocalisation();

  const isAuthenticated = useKioskSession((session) =>
    Boolean(session?.childId)
  );
  const diningOption = useKioskDiningOption();

  const {
    mutate: findProduct,
    status: findProductStatus,
    reset: resetFindProduct
  } = useFindProductKiosk();
  const {
    mutate: identifyUser,
    status: identifyUserStatus,
    reset: resetIdentifyUser
  } = useIdentifyUser();

  return (
    <>
      <ScannerListener
        isUserAuthenticated={isAuthenticated}
        enabled={canScan(pathname)}
        onIdentifyProductOrUser={(value) => {
          // TO-DO: [POS-2411] support scanning product barcodes from landing page
          if (pathname === "/kiosk") {
            scanToastError(null, <T _str="Scan your app below" />);
            return;
          }

          findProduct(value);
        }}
        onIdentifyUser={(value) => {
          identifyUser(
            {
              userIdentifier: value,
              diningOption
            },
            {
              onSuccess: (data) => {
                if (!data.user) {
                  throw new Error("User not found");
                }

                if (pathname === "/kiosk") {
                  kioskActions.session.start({
                    locale
                  });
                }

                kioskActions.user.setChildId(data.user.childId);
              },
              onError: (error) => {
                scanToastError(error);
              }
            }
          );
        }}
      />

      <ModalLoadingGeneric open={identifyUserStatus === "pending"} />

      <ModalErrorQr
        open={identifyUserStatus === "error"}
        onClose={resetIdentifyUser}
      />

      <ModalErrorBarcode
        open={findProductStatus === "error"}
        onClose={resetFindProduct}
      />
    </>
  );
};
